import React, { Suspense, useLayoutEffect, useMemo } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { RedirectAs404 } from "../utils/Utils";

import BankAccountManager from "../pages/bankaccountmanager/BankAccountManager";
import BillApprovedManager from "../pages/billmanager/BillApprovedManager";
import BillCreate from "../pages/billmanager/BillCreate";
import BillManager from "../pages/billmanager/BillManager";
import BillStation from "../pages/billmanager/BillStation";
import CategoryManager from "../pages/categorymanager/CategoryManager";
import CustomerManager from "../pages/customermanager/CustomerManager";
import UserManager from "../pages/employeemanager/UserManager";
import IngredientManager from "../pages/ingredientmanager/IngredientManager";
import IngredientPriceManager from "../pages/ingredientpricemanager/IngredientPriceManager";
import ReportAllMortgageContract from "../pages/loancontractmanager/ReportAllMortgageContract";
import ReportAllMortgageContractDetailContract from "../pages/loancontractmanager/ReportAllMortgageContractDetailContract";
import UserProfileLayout from "../pages/profile/UserProfileLayout";
import CategoryReport from "../pages/report/CategoryReport";
import DailyReport from "../pages/report/DailyReport";
import IngredientReport from "../pages/report/IngredientReport";
import MonthlyReport from "../pages/report/MonthlyReport";
import ReportAllBankAccounts from "../pages/report/ReportAllBankAccounts";
import ReportAllCustomer from "../pages/report/ReportAllCustomer";
import ReportByCustomer from "../pages/report/ReportByCustomer";
import ReportTransactionHistory from "../pages/report/ReportTransactionHistory";
import PNBillUpdateByWeighingSlip from "../pages/selfEmployeeManager/PNBillUpdateByWeighingSlip";
import SumaryStatementManager from "../pages/sumaryStatementManager/SumaryStatementManager";
import TruckConfigManager from "../pages/truckconfigmanager/TruckConfigManager";
import TruckManager from "../pages/truckmanager/TruckManager";

import AddCustomerMoneyFlow from "../pages/customermanager/AddCustomerMoneyFlow";
import CustomerMoneyFlowByCustomer from "../pages/customermanager/CustomerMoneyFlowByCustomer";
import DeliveryFeeManager from "../pages/deliveryFee/DeliveryFeeManager";
import AddEmployee from "../pages/employeemanager/AddEmployee";
import EmployeePayInOutManager from "../pages/employeemanager/PayInOutManager";
import PieceWageCategoryManager from "../pages/employeemanager/PieceWageCategoryManager";
import PieceWageManager from "../pages/employeemanager/PieceWageManager";
import PieceWageSummary from "../pages/employeemanager/PieceWageSummary";
import SalaryPerMonth from "../pages/employeemanager/SalaryPerMonth";
import TimeKeepingManager from "../pages/employeemanager/TimeKeepingManager";
import TimeKeepingScheduling from "../pages/employeemanager/TimeKeepingScheduling";
import HolidayManager from "../pages/holidaymanager/HolidayManager";
import InventoryIn from "../pages/inventorymanager/InventoryIn";
import InventoryOutInside from "../pages/inventorymanager/InventoryOutInside";
import InventoryPackManager from "../pages/inventorymanager/InventoryPackManager";
import InventoryPackSummary from "../pages/inventorymanager/InventoryPackSummary";
import InventorySummary from "../pages/inventorymanager/InventorySummary";
import InventoryTransportReport from "../pages/inventorymanager/InventoryTransportReport";
import InventoryTruckMonitor from "../pages/inventorymanager/InventoryTruckMonitor";
import PNInventoryOutOutside from "../pages/inventorymanager/PNInventoryOutOutside";
import LoanContractManager from "../pages/loancontractmanager/LoanContractManager";
import PNReportAllCustomer from "../pages/pn/PNReportAllCustomer";
import PNReportDriverCostAdvance from "../pages/pn/PNReportDriverCostAdvance";
import PNReportDriverSalary from "../pages/pn/PNReportDriverSalary";
import PNReportFee from "../pages/pn/PNReportFee";
import PNReportMoneyFlowDriver from "../pages/pn/PNReportMoneyFlowDriver";
import PNReportTransaction from "../pages/pn/PNReportTransaction";
import PNSumaryStatementManager from "../pages/pn/PNSumaryStatementManager";
import ScanQRSystem from "../pages/selfEmployeeManager/ScanQRSystem";
import TransactionHistoryBankAccountManager from "../pages/transactionhistorymanager/TransactionHistoryBankAccountManager";
import UpsertTransactionHistory from "../pages/transactionhistorymanager/UpsertTransactionHistory";

import BillPreviewUpdate from "../pages/billmanager/BillPreviewUpdate";
import BillPreviewUpdateManager from "../pages/billmanager/BillPreviewUpdateManager";
import CustomerMoneyFlowPreviewUpdateManager from "../pages/customermanager/CustomerMoneyFlowPreviewUpdateManager";
import EmployeeDayOffManager from "../pages/employeeDayOff/EmployeeDayOffManager";
import UpsertInventoryOutInside from "../pages/inventorymanager/UpsertInventoryOutInside";
import MortgageContractTransactionHistory from "../pages/loancontractmanager/MortgageContractTransactionHistory";
import PNCategoryManager from "../pages/pn/PNCategoryManager";
import PNCustomerManager from "../pages/pn/PNCustomerManager";
import PNReportAllBankAccounts from "../pages/pn/PNReportAllBankAccounts";
import PNReportByCustomer from "../pages/pn/PNReportByCustomer";
import DeliveryReport from "../pages/report/DeliveryReport";
import ReportApprovedTransactionHistory from "../pages/report/ReportApprovedTransactionHistory";
import MyDriverBonus from "../pages/selfEmployeeManager/MyDriverBonus";
import MyPieceWageManager from "../pages/selfEmployeeManager/MyPieceWageManager";
import MySalaryPerMonth from "../pages/selfEmployeeManager/MySalaryPerMonth";
import MyTimeKeepingManager from "../pages/selfEmployeeManager/MyTimeKeepingManager";
import MyTimeKeepingScheduling from "../pages/selfEmployeeManager/MyTimeKeepingScheduling";
import BillExternalContractSetting from "../pages/setting/BillExternalContractSetting";
import Setting from "../pages/setting/Setting";
import TaxManager from "../pages/tax/TaxManager";
import TaxReport from "../pages/tax/TaxReport";
import TransactionHistoryPreviewUpdateManager from "../pages/transactionhistorymanager/TransactionHistoryPreviewUpdateManager";
import WarehouseManager from "../pages/warehouse/WarehouseManager";

import DraffBillManager from "../pages/billmanager/DraffBillManager";
import EmployeeLeaveManager from "../pages/employeeLeave/EmployeeLeaveManager";
import EmployeePortionManager from "../pages/employeemanager/EmployeePortionManager";
import IngredientExchange from "../pages/ingredientExchange/IngredientExchange";
import Inventory from "../pages/inventorymanager/Inventory";
import DriveRentalContract from "../pages/pn/DriveRentalContract";
import PNContainerDownFee from "../pages/pn/PNContainerDownFee";
import PNContainerFee from "../pages/pn/PNContainerFee";
import PNDeliveryFeeByDistance from "../pages/pn/PNDeliveryFeeByDistance";
import PNReportPN from "../pages/pn/PNReportPN";
import PNReportTruckProfit from "../pages/pn/PNReportTruckProfit";
import PNTireManager from "../pages/pn/PNTireManager";
import PNSeaportManager from "../pages/pn/PNSeaportManager";
import ReportAssignStaffMoneyFlowPN from "../pages/report/ReportAssignStaffMoneyFlowPN";
import ReportAssignTransactionHistoryPN from "../pages/report/ReportAssignTransactionHistoryPN";
import MyBillForRentalContractManager from "../pages/selfEmployeeManager/MyBillForRentalContractManager";
import MyBillForStaffMoneyFlowDetail from "../pages/selfEmployeeManager/MyBillForStaffMoneyFlowDetail";
import MyBillForStaffMoneyFlowManager from "../pages/selfEmployeeManager/MyBillForStaffMoneyFlowManager";
import MyInventoryOutOutside from "../pages/selfEmployeeManager/MyInventoryOutOutside";

import BankHookTransactionDetail from '../pages/bankHookTransactions/BankHookTransactionDetail';
import BankHookTransactions from '../pages/bankHookTransactions/BankHookTransactions';
import PNBankHookTransactionDetail from '../pages/pn/PNBankHookTransactionDetail';
import PNBankHookTransactions from '../pages/pn/PNBankHookTransactions';
import PNBankAccountManager from "../pages/bankaccountmanager/PNBankAccountManager";
import BillOtherCreate from '../pages/billOtherManager/BillOtherCreate';
import BillOtherManager from '../pages/billOtherManager/BillOtherManager';

import BillOtherMustRequestCreate from '../pages/billOtherMustRequestManager/BillOtherMustRequestCreate';
import BillOtherMustRequestManager from '../pages/billOtherMustRequestManager/BillOtherMustRequestManager';


import BillExternalContractByMonth from "../pages/billexternalcontractmanager/BillExternalContractByMonth";
import BillExternalContractCreate from "../pages/billexternalcontractmanager/BillExternalContractCreate";
import BillExternalContractEstimate from '../pages/billexternalcontractmanager/BillExternalContractEstimate';
import BillExternalContractManager from "../pages/billexternalcontractmanager/BillExternalContractManager";
import BillScalerUpdate from "../pages/billmanager/BillScalerUpdate";
import CustomerBankAccountManager from '../pages/customermanager/CustomerBankAccountManager';
import EmployeeTemplateManager from '../pages/employeemanager/EmployeeTemplateManager';
import BillExternalPortFeeCreate from '../pages/externalportfeemanager/BillExternalPortFeeCreate';
import BillExternalPortFeeManager from '../pages/externalportfeemanager/BillExternalPortFeeManager';
import LocationDistanceManager from '../pages/locationdistance/LocationDistanceManager';
import MaterialInventoryRequest from '../pages/material/MaterialInventoryRequest';
import MaterialInventoryRequestUpsert from '../pages/material/MaterialInventoryRequestUpsert';
import MaterialManager from '../pages/material/MaterialManager';
import MaterialSummary from '../pages/material/MaterialSummary';
import PNReportDriverBonus from "../pages/pn/PNReportDriverBonus";
import PnBill from '../pages/pn/bill/PnBill';
import PnBillManager from '../pages/pn/bill/PnBillManager';
import PnBillStaffMoneyFlow from '../pages/pn/bill/PnBillStaffMoneyFlow';
import PnBillStaffMoneyFlowManager from '../pages/pn/bill/PnBillStaffMoneyFlowManager';
import IngredientExchangeHistoryReport from "../pages/report/IngredientExchangeHistoryReport";
import MyTasks from '../pages/task/MyTasks';
import ReportTask from '../pages/task/ReportTask';
import TaskManager from "../pages/task/TaskManager";

import PNTransactionHistoryBankAccountManager from "../pages/pn/PNTransactionHistoryBankAccountManager";
import PnBillExternalPortFee from '../pages/pn/bill/PnBillExternalPortFee';
import PnBillExternalPortFeeManager from '../pages/pn/bill/PnBillExternalPortFeeManager';
import PnBillOther from '../pages/pn/bill/PnBillOther';
import PnBillOtherManager from '../pages/pn/bill/PnBillOtherManager';
import IngredientScheduleManager from '../pages/ingredientSchedule/IngredientScheduleManager';
import PNRequestBillDispatch from '../pages/pn/pnRequestBill/PNRequestBillDispatch';
import PNRequestBillManager from '../pages/pn/pnRequestBill/PNRequestBillManager';
import MyBillForExternalPortFeeDetail from "../pages/selfEmployeeManager/MyBillForExternalPortFeeDetail";
import MyBillForExternalPortFeeManager from "../pages/selfEmployeeManager/MyBillForExternalPortFeeManager";
import MyBillForRentalContractDetail from "../pages/selfEmployeeManager/MyBillForRentalContractDetail";
import { useUser } from "../context/user";
import BillByHandlerIngredientPriceHistory from "../pages/report/BillByHandlerIngredientPriceHistory";
import MonthlyCommissionReport from "../pages/report/MonthlyCommissionReport";
import SaleCommissionSettingManager from "../pages/sale-commission-setting/SaleCommissionSettingManager";
import ProcessingUnitPriceManager from "../pages/processing/ProcessingUnitPriceManager";
import ProcessingInventory from "../pages/processing/ProcessingInventory";
const Pages = () => {

  const {
    state: {
      user,
    },
  } = useUser();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });


  const arrRouters = useMemo(() => {
    const arr = [
      <Route exact path={`/sale-commission-setting`} component={SaleCommissionSettingManager}></Route>,
      <Route exact path={`/processing-unit-price`} component={ProcessingUnitPriceManager}></Route>,
      <Route exact path={`/processing-inventory`} component={ProcessingInventory}></Route>,
      <Route exact path={`/processing-bill`} render={(props) => <BillManager {...props} isProcessing />}></Route>,
      <Route exact path={`/processing-bill/create`} render={(props) => <BillCreate {...props} isProcessing />}></Route>,
      <Route exact path={`/processing-bill/:id`} render={(props) => <BillCreate {...props} isProcessing />}></Route>,
      <Route exact path={`/ingredient-exchange`} component={IngredientExchange}></Route>,
      <Route exact path={`/holiday`} component={HolidayManager}></Route>,
      <Route exact path={`/daily-report`} component={DailyReport}></Route>,
      <Route
        exact
        path={`/bill-other`}
        component={BillOtherManager}
      ></Route>,
      <Route
        exact
        path={`/bill-other/create`}
        component={BillOtherCreate}
      ></Route>,
      <Route
        exact
        path={`/bill-other/:id`}
        component={BillOtherCreate}
      ></Route>,
      <Route
        exact
        path={`/bill-other-must-request`}
        component={BillOtherMustRequestManager}
      ></Route>,
      <Route
        exact
        path={`/bill-other-must-request/create`}
        component={BillOtherMustRequestCreate}
      ></Route>,
      <Route
        exact
        path={`/bill-other-must-request/:id`}
        component={BillOtherMustRequestCreate}
      ></Route>,

      <Route
        exact
        path={`/bill-external-port-fee`}
        component={BillExternalPortFeeManager}
      ></Route>,
      <Route
        exact
        path={`/bill-external-port-fee/create`}
        component={BillExternalPortFeeCreate}
      ></Route>,
      <Route
        exact
        path={`/bill-external-port-fee/:id`}
        component={BillExternalPortFeeCreate}
      ></Route>,

      <Route
        exact
        path={`/pn/bill`}
        component={PnBillManager}
      ></Route>,
      <Route
        exact
        path={`/pn/bill/create`}
        component={PnBill}
      ></Route>,
      <Route
        exact
        path={`/pn/bill/:id`}
        component={PnBill}
      ></Route>,


      <Route
        exact
        path={`/pn/bill-staff-money-flow`}
        component={PnBillStaffMoneyFlowManager}
      ></Route>,
      <Route
        exact
        path={`/pn/bill-staff-money-flow/create`}
        component={PnBillStaffMoneyFlow}
      ></Route>,
      <Route
        exact
        path={`/pn/bill-staff-money-flow/:id`}
        component={PnBillStaffMoneyFlow}
      ></Route>,


      <Route
        exact
        path={`/pn/bill-external-port-fee`}
        component={PnBillExternalPortFeeManager}
      ></Route>,

      <Route
        exact
        path={`/pn/bill-external-port-fee/create`}
        component={PnBillExternalPortFee}
      ></Route>,
      <Route
        exact
        path={`/pn/bill-external-port-fee/:id`}
        component={PnBillExternalPortFee}
      ></Route>,

      <Route
        exact
        path={`/pn/bill-other`}
        component={PnBillOtherManager}
      ></Route>,

      <Route
        exact
        path={`/pn/bill-other/create`}
        component={PnBillOther}
      ></Route>,
      <Route
        exact
        path={`/pn/bill-other/:id`}
        component={PnBillOther}
      ></Route>,
      <Route
        exact
        path={`/pn/transaction-history/:bankAccountId`}
        component={PNTransactionHistoryBankAccountManager}
      ></Route>,


      <Route
        exact
        path={`/bill-external-contract/create`}
        component={BillExternalContractCreate}
      ></Route>,
      <Route
        exact
        path={`/bill-external-contract-estimate/:id`}
        component={BillExternalContractEstimate}
      ></Route>,
      <Route
        exact
        path={`/bill-external-contract/:id`}
        component={BillExternalContractCreate}
      ></Route>,

      <Route
        exact
        path={`/bill-external-contract`}
        component={BillExternalContractManager}
      ></Route>,
      <Route
        exact
        path={`/bill-external-contract-by-month`}
        component={BillExternalContractByMonth}
      ></Route>,

      <Route
        exact
        path={`/delivery-report`}
        component={DeliveryReport}
      ></Route>,
      <Route
        exact
        path={`/report/report-commission-per-month`}
        component={BillByHandlerIngredientPriceHistory}
      ></Route>,
      <Route
        exact
        path={`/report/monthly-commission`}
        component={MonthlyCommissionReport}
      ></Route>,
      <Route
        exact
        path={`/report/ingredient-exchange-history`}
        component={IngredientExchangeHistoryReport}
      ></Route>,
      <Route
        exact
        path={`/report/report-ingredient`}
        component={IngredientReport}
      ></Route>,
      <Route
        exact
        path={`/report/report-category`}
        component={CategoryReport}
      ></Route>,

      <Route
        exact
        path={`/report/report-all-bank-accounts`}
        component={ReportAllBankAccounts}
      ></Route>,
      <Route
        exact
        path={`/report/monthly-report`}
        component={MonthlyReport}
      ></Route>,

      <Route
        exact
        path={`/customer/report-all-customer`}
        component={ReportAllCustomer}
      ></Route>,
      <Route
        exact
        path={`/customer/report-by-customer/:customerId`}
        component={ReportByCustomer}
      ></Route>,
      <Route
        exact
        path={`/pn-bill/update-by-weighing-slip/:encryptData`}
        component={PNBillUpdateByWeighingSlip}
      ></Route>,
      <Route
        exact
        path={`/bill/detail-request-update-bill/:id`}
        component={BillPreviewUpdate}
      ></Route>,

      <Route
        exact
        path={`/bill/list-request-update-bill`}
        component={BillPreviewUpdateManager}
      ></Route>,
      <Route exact path={`/bill`} component={BillManager}></Route>,
      <Route exact path={`/draff-bill`} component={DraffBillManager}></Route>,

      <Route exact path={`/bill/create`} component={BillCreate}></Route>,

      <Route exact path={`/bill/:id`} component={BillCreate}></Route>,
      <Route
        exact
        path={`/bill-approved`}
        component={BillApprovedManager}
      ></Route>,

      <Route
        exact
        path={`/bill-station`}
        component={BillStation}
      ></Route>,

      <Route exact path={`/user`} component={UserManager}></Route>,

      <Route
        exact
        path={`/employee-scheduling`}
        component={TimeKeepingScheduling}
      ></Route>,
      <Route
        exact
        path={`/summary-statement`}
        component={SumaryStatementManager}
      ></Route>,
      <Route
        exact
        path={`/time-keeping`}
        component={TimeKeepingManager}
      ></Route>,

      <Route
        exact
        path={`/employee-pay-in-out`}
        component={EmployeePayInOutManager}
      ></Route>,

      <Route
        exact
        path={`/salary-per-month`}
        component={SalaryPerMonth}
      ></Route>,
      <Route exact path={`/user/create`} component={AddEmployee}></Route>,
      <Route exact path={`/user/:id`} component={AddEmployee}></Route>,

      <Route exact path={`/ingredient`} component={IngredientManager}></Route>,
      <Route
        exact
        path={`/ingredient-price`}
        component={IngredientPriceManager}
      ></Route>,

      <Route
        exact
        path={`/customer-money-flow/list-preview-update-manager`}
        component={CustomerMoneyFlowPreviewUpdateManager}
      ></Route>,

      <Route
        exact
        path={`/customer/:customerId/customer-money-flow/:id`}
        component={AddCustomerMoneyFlow}
      ></Route>,
      <Route
        exact
        path={`/bank-account/money/:bankAccountId`}
        component={TransactionHistoryBankAccountManager}
      ></Route>,

      <Route
        exact
        path={`/customer/:customerId/customer-bank-account`}
        component={CustomerBankAccountManager}
      ></Route>,



      <Route
        exact
        path={`/material`}
        component={MaterialManager}
      ></Route>,
      <Route
        exact
        path={`/material-summary`}
        component={MaterialSummary}
      ></Route>,
      <Route
        exact
        path={`/material-inventory-request`}
        component={MaterialInventoryRequest}
      ></Route>,

      <Route
        exact
        path={`/material-inventory-request/:id`}
        component={MaterialInventoryRequestUpsert}
      ></Route>,


      <Route
        exact
        path={`/customer/money/:customerId`}
        component={CustomerMoneyFlowByCustomer}
      ></Route>,

      <Route
        exact
        path={`/report/transaction`}
        component={ReportTransactionHistory}
      ></Route>,
      <Route
        exact
        path={`/report/approved-transaction`}
        component={ReportApprovedTransactionHistory}
      ></Route>,

      <Route
        exact
        path={`/transaction/:type/:id`}
        component={UpsertTransactionHistory}
      ></Route>,
      <Route
        exact
        path={`/transaction-history/list-preview-update-manager`}
        component={TransactionHistoryPreviewUpdateManager}
      ></Route>,

      <Route exact path={`/truck`} component={TruckManager}></Route>,
      <Route
        exact
        path={`/truck-config`}
        component={TruckConfigManager}
      ></Route>,
      <Route
        exact
        path={`/delivery-fee`}
        component={DeliveryFeeManager}
      ></Route>,
      <Route
        exact
        path={`/location-distance-manager`}
        component={LocationDistanceManager}
      ></Route>,
      <Route exact path={`/scan-qr-system`} component={ScanQRSystem}></Route>,
      <Route
        exact
        path={`/setting/price-wage-category`}
        component={PieceWageCategoryManager}
      ></Route>,
      <Route
        exact
        path={`/employee/piece-wage`}
        component={PieceWageManager}
      ></Route>,

      <Route exact path={`/tax`} component={TaxManager}></Route>,
      <Route exact path={`/tax-report`} component={TaxReport}></Route>,
      <Route
        exact
        path={`/inventory-pack-transaction`}
        component={InventoryPackManager}
      ></Route>,

      <Route
        exact
        path={`/inventory-pack-summary`}
        component={InventoryPackSummary}
      ></Route>,
      <Route exact path={`/inventory`} component={Inventory}></Route>,

      <Route
        exact
        path={`/piece-wage-summary-by-categories`}
        component={PieceWageSummary}
      ></Route>,

      <Route
        exact
        path={`/loan-contract`}
        component={LoanContractManager}
      ></Route>,
      <Route
        exact
        path={`/mortgage-transaction-history`}
        component={MortgageContractTransactionHistory}
      ></Route>,

      <Route
        exact
        path={`/report/report-mortgage-contracts`}
        component={ReportAllMortgageContract}
      ></Route>,
      <Route
        exact
        path={`/report/report-mortgage-contracts-detail-contracts`}
        component={ReportAllMortgageContractDetailContract}
      ></Route>,

      <Route
        exact
        path={`/bank-account`}
        component={BankAccountManager}
      ></Route>,

      <Route
        exact
        path={`/pn/bank-account`}
        component={PNBankAccountManager}
      ></Route>,
      <Route
        exact
        path={`/pn/report/transaction`}
        component={
          PNReportTransaction
        }
      ></Route>,

      <Route exact path={`/customer`}>
        <CustomerManager />
      </Route>,
      <Route exact path={`/pn/customer`}>
        <PNCustomerManager />
      </Route>,
      <Route exact path={`/category`} component={CategoryManager}></Route>,

      <Route
        exact
        path={`/pn/category`}
        component={PNCategoryManager}
      ></Route>,
      <Route
        exact
        path={`/pn/report-all-customer`}
        component={PNReportAllCustomer}
      ></Route>,
      <Route
        exact
        path={`/pn/report-by-customer/:customerId`}
        component={PNReportByCustomer}
      ></Route>,
      <Route
        exact
        path={`/pn/report/report-all-bank-accounts`}
        component={PNReportAllBankAccounts}
      ></Route>,
      <Route
        exact
        path={`/pn/container-fee`}
        component={PNContainerFee}
      ></Route>,
      <Route
        exact
        path={`/pn/delivery-fee-by-distance`}
        component={PNDeliveryFeeByDistance}
      ></Route>,
      <Route
        exact
        path={`/pn/drive-rental-contract`}
        component={DriveRentalContract}
      ></Route>,

      <Route
        exact
        path={`/pn/summary-statement`}
        component={PNSumaryStatementManager}
      ></Route>,
      <Route
        exact
        path={`/pn/salary-per-month`}
        component={PNReportDriverSalary}
      ></Route>,
      <Route
        exact
        path={`/pn/report-money-flow-driver`}
        component={PNReportMoneyFlowDriver}
      ></Route>,
      <Route
        exact
        path={`/pn/report-driver-cost-advance`}
        component={PNReportDriverCostAdvance}
      ></Route>,
      <Route exact path={`/pn/report-fee`} component={PNReportFee}></Route>,
      <Route exact path={`/pn/tire`} component={PNTireManager}></Route>,
      <Route exact path={`/pn/seaport`} component={PNSeaportManager}></Route>,
      <Route exact path={`/ingredient-schedule`} component={IngredientScheduleManager}></Route>,
      <Route exact path={`/pn-request-bill`} component={PNRequestBillManager}></Route>,
      <Route exact path={`/pn-request-bill/:id`} component={PNRequestBillDispatch}></Route>,
      <Route exact path={`/pn/report-truck-profit`} component={PNReportTruckProfit}></Route>,
      <Route
        exact
        path={`/pn/employee-leave`}
        component={EmployeeLeaveManager}
      ></Route>,

      <Route exact path={`/inventory-in`} component={InventoryIn}></Route>,
      <Route exact path={`/inventory-in`} component={InventoryIn}></Route>,
      <Route
        exact
        path={`/inventory-out-inside`}
        component={InventoryOutInside}
      ></Route>,
      <Route
        exact
        path={`/pn-inventory-out-outside`}
        component={PNInventoryOutOutside}
      ></Route>,
      <Route
        exact
        path={`/inventory-summary`}
        component={InventorySummary}
      ></Route>,
      <Route
        exact
        path={`/transport-report`}
        component={InventoryTransportReport}
      ></Route>,
      <Route
        exact
        path={`/truck-monitor`}
        component={InventoryTruckMonitor}
      ></Route>,
      <Route exact path={`/profile`} component={UserProfileLayout}></Route>,
      <Route
        exact
        path={`/my-employee-scheduling`}
        component={MyTimeKeepingScheduling}
      ></Route>,
      <Route
        exact
        path={`/my-time-keeping`}
        component={MyTimeKeepingManager}
      ></Route>,
      <Route
        exact
        path={`/my-salary-per-month`}
        component={MySalaryPerMonth}
      ></Route>,
      <Route
        exact
        path={`/my-driver-bonus`}
        component={MyDriverBonus}
      ></Route>,
      <Route
        exact
        path={`/my-piece-wage`}
        component={MyPieceWageManager}
      ></Route>,
      <Route
        exact
        path={`/my-bill-for-staff-money-flow-manager`}
        component={MyBillForStaffMoneyFlowManager}
      ></Route>,

      <Route
        exact
        path={`/my-bill-for-staff-money-flow-detail/create`}
        component={MyBillForStaffMoneyFlowDetail}
      ></Route>,

      <Route
        exact
        path={`/my-bill-for-staff-money-flow-detail/:id`}
        component={MyBillForStaffMoneyFlowDetail}
      ></Route>,

      <Route
        exact
        path={`/my-bill-for-external-port-fee`}
        component={MyBillForExternalPortFeeManager}
      ></Route>,

      <Route
        exact
        path={`/my-bill-for-external-port-fee-detail/create`}
        component={MyBillForExternalPortFeeDetail}
      ></Route>,

      <Route
        exact
        path={`/my-bill-for-external-port-fee-detail/:id`}
        component={MyBillForExternalPortFeeDetail}
      ></Route>,



      <Route
        exact
        path={`/my-bill-for-rental-contract-manager`}
        component={MyBillForRentalContractManager}
      ></Route>,
      <Route
        exact
        path={`/my-bill-for-rental-contract-detail/create`}
        component={MyBillForRentalContractDetail}
      ></Route>,

      <Route
        exact
        path={`/my-bill-for-rental-contract-detail/:id`}
        component={MyBillForRentalContractDetail}
      ></Route>,


      <Route
        exact
        path={`/my-inventory-out-outside-transaction`}
        component={MyInventoryOutOutside}
      ></Route>,

      <Route
        exact
        path={`/inventory-out-inside/:id`}
        component={UpsertInventoryOutInside}
      ></Route>,
      <Route
        exact
        path={`/employee-day-off`}
        component={EmployeeDayOffManager}
      ></Route>,
      <Route exact path={`/warehouse`} component={WarehouseManager}></Route>,


      <Route exact path={`/setting`} component={Setting}></Route>,
      <Route exact path={`/setting-bill-external-contract`} component={BillExternalContractSetting}></Route>,

      <Route exact path={`/pn/report-pn`} component={PNReportPN}></Route>,
      <Route
        exact
        path={`/pn/container-down-fee`}
        component={PNContainerDownFee}
      ></Route>,




      <Route
        exact
        path={`/employee-portion`}
        component={EmployeePortionManager}
      ></Route>,
      <Route
        exact
        path={`/report/assign-transaction-history-pn`}
        component={ReportAssignTransactionHistoryPN}
      ></Route>,

      <Route
        exact
        path={`/report/assign-staff-money-flow-pn`}
        component={ReportAssignStaffMoneyFlowPN}
      ></Route>,
      <Route
        exact
        path={`/employee-template`}
        component={EmployeeTemplateManager}
      ></Route>,
      <Route
        exact
        path={`/bank-hook-transactions`}
        component={BankHookTransactions}
      ></Route>,
      <Route
        exact
        path={`/bank-hook-transactions/:id`}
        component={BankHookTransactionDetail}
      ></Route>,
      <Route
        exact
        path={`/pn/bank-hook-transactions`}
        component={PNBankHookTransactions}
      ></Route>,
      <Route
        exact
        path={`/pn/bank-hook-transactions/:id`}
        component={PNBankHookTransactionDetail}
      ></Route>,

      <Route
        exact
        path={`/my-tasks`}
        component={MyTasks}
      ></Route>,
      <Route
        exact
        path={`/report/tasks`}
        component={ReportTask}
      ></Route>,
      <Route
        exact
        path={`/task-categories`}
        component={TaskManager}
      ></Route>,
      <Route
        exact
        path={`/pn/report-driver-bonus`}
        component={PNReportDriverBonus}
      ></Route>,
      <Route
        exact
        path={`/bill/update-by-scaler/:encryptData`}
        component={BillScalerUpdate}
      ></Route>,
      <Route component={RedirectAs404}></Route>,
    ]
    if (user.username === 'yen_anh') {
      return arr.filter((router) => {
        return [
          '/bill-other',
          '/bill-other/create',
          '/bill-other/:id',
          '/salary-per-month',
          '/tax',
          '/tax-report',
        ].includes(router?.props?.path)
      });
    }
    return arr;
  }, [user])

  return (
    <Suspense fallback={<div />}>
      <Switch>
        <Redirect exact path={`/`} to={"/scan-qr-system"}></Redirect>
        {arrRouters}
      </Switch>
    </Suspense>
  );
};
export default Pages;
